import React from "react";
import PropTypes from "prop-types";
import Background from "./Background";
import ProductMask from "./ProductMask";
import PrintArea from "./PrintArea";
import Guides from "./Guides";
import "./Layer.css";

class Layer extends React.Component {
  calculatePosition = () => {
    let position = {};
    const scale = 72 * this.props.design.preview_scale;

    // SET WIDTH/HEIGHT/TOP/LEFT
    if (this.props.layer.height > 0) {
      position.height = this.props.layer.height * scale;
    } else {
      //TODO check on use_color_mask, layer_mask, use_product_mask are used
      if (
        this.props.layer.has_color === true ||
        this.props.layer.use_color_mask === true ||
        this.props.layer.layer_mask === true ||
        this.props.layer.use_product_mask === true
      ) {
        position.height = "100%";
      }
    }

    if (this.props.layer.width > 0) {
      position.width = this.props.layer.width * scale;
    } else {
      if (
        this.props.layer.has_color === true ||
        this.props.layer.use_color_mask === true ||
        this.props.layer.layer_mask === true ||
        this.props.layer.use_product_mask === true
      ) {
        position.width = "100%";
      }
    }

    // CONVERT FROM INCHES TO PIXELS
    position.top = this.props.layer.top_position * scale;
    position.left = this.props.layer.left_position * scale;

    return position;
  };

  render() {
    const position = this.calculatePosition(),
      allowGuides = this.props.layer.allow_image || this.props.layer.allow_text,
      guidesVisible = this.props.guidesVisible ? "guides-visible" : "";

    return (
      <div className={`layer noselect ${guidesVisible}`} style={position}>
        <Background layer={this.props.layer} design={this.props.design} />
        <ProductMask layer={this.props.layer} />
        <PrintArea
          layerId={this.props.layer.layer_id}
          textElements={this.props.layer.text_elements}
          imageElements={this.props.layer.image_elements}
          design={this.props.design}
          bleed={this.props.bleed}
          guidesVisible={this.props.guidesVisible}
          disableInteractivity={this.props.disableInteractivity}
          onShow2ndTip={this.props.onShow2ndTip}
          didShow2ndTip={this.props.didShow2ndTip}
          handleHide2ndTip={this.props.handleHide2ndTip}
          handleIsDragging={this.props.handleIsDragging}
          isDraggingSelected={this.props.isDraggingSelected}
          allowImage={this.props.layer.allow_image}
          allowPhoto={this.props.layer.photo_image}
          allowText={this.props.layer.allow_text}
        />

        {allowGuides && (
          <Guides
            guidesVisible={this.props.guidesVisible}
            position={position}
          />
        )}
      </div>
    );
  }
}

Layer.propTypes = {
  layer: PropTypes.object,
  design: PropTypes.object,
};

export default Layer;
